export default {
  data(){
    return {
      noScrollClass   : 'akibatrical-noscroll',
      scrollPositionY : null,
    };
  },

  computed  : {
    isBodyNoScroll(){
      return this.$store.state.layouts.isBodyNoScroll;
    }
  },

  watch : {
    isBodyNoScroll(newValue) {
      switch(newValue){
        case true:
          this.bodyScrollCancelOn();
        break;

        case false:
          this.bodyScrollCancelOff();
        break;
      }
    },

    scrollPositionY(data){
      if(data === null){
        document.querySelector('body').style.top = null;
      }else{
        document.querySelector('body').style.top = -(data)+'px';
      }
    }
  },

  methods : {
    bodyScrollCancelOn(){
      if(!document.querySelector('body').classList.contains(this.noScrollClass)){
        this.scrollPositionY = window.scrollY;
        
        document.querySelector('body').classList.add(this.noScrollClass);
      }
    },

    bodyScrollCancelOff(){
      if(document.querySelector('body').classList.contains(this.noScrollClass)){
        document.querySelector('body').classList.remove(this.noScrollClass);
        
        window.scrollTo(0, this.scrollPositionY);
        this.scrollPositionY = null;
      }
    }
  }
}
